import React from 'react';
import { RoutePermittedRole } from 'shared/constants/AppConst';
const BusinessUnitList= React.lazy(()=>import ('./AccordianList'))
const BusinessUnitForm=React.lazy(()=>import ('./BussinessUnit'))

export const BusinessUnitConfigs = [
    {
      permittedRole: RoutePermittedRole.ALL,
      path: '/onboard-tenant/bussiness-unit/table',
      element: <BusinessUnitList />,
    },
    {
        permittedRole: RoutePermittedRole.corporateAdmin,
        path: '/onboard-tenant/bussiness-unit/form',
        element: <BusinessUnitForm />,
      },
  ];
  